import './inputBaseModuleAugmentation';
import React from 'react';
import {
  InputBase as MuiInputBase,
  InputBaseProps as MuiInputBaseProps,
} from '@mui/material';

/**
 * Props that we do not want to include with InputBase.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
export type InputBaseBlockedProps = keyof Pick<MuiInputBaseProps, 'color'>;

/**
 * @deprecated Unsupported component: This is an internal component, use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export type InputBaseProps = Omit<MuiInputBaseProps, InputBaseBlockedProps>;

/**
 * @deprecated Unsupported component: This is an internal component, use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
// eslint-disable-next-line deprecation/deprecation
export const InputBase = React.forwardRef<HTMLElement, InputBaseProps>(
  function UnifyInputBase(props, ref) {
    return <MuiInputBase {...props} ref={ref} />;
  }
);
